<h2 mat-dialog-title>
  {{ 'LISTS.LIST_DIALOG.ADD_NAME_TO_LIST' | translate : { name: this.accountGroup.napData.companyName } }}
</h2>
<mat-dialog-content [formGroup]="form" class="{{ !!searchSelect && searchSelect.isSelecting ? 'search-open' : '' }}">
  <mat-tab-group [selectedIndex]="0" (selectedIndexChange)="selectedIndex = $event" #matTabGroup>
    <mat-tab [label]="'LISTS.LIST_DIALOG.ADD_TO_EXISTING_LIST' | translate">
      <div class="tab-container">
        @if (actionListsStoreService.actionLists$ | async; as lists) {
          @if ((lists || []).length > 0) {
            <label>
              {{ 'LISTS.LIST_DIALOG.CHOOSE_LIST' | translate }}
            </label>
            <uikit-search-select
              #searchSelect
              [formControlName]="'existingLists'"
              [options]="actionListsStoreService.actionLists$ | async"
              [showSearch]="true"
              [placeholderText]="'LISTS.LIST_DIALOG.SELECT_A_LIST' | translate"
              [displayProperty]="'name'"
              [selected]="selectedList"
              [width]="500"
              (selection)="selectedList = $event"
            ></uikit-search-select>
          } @else {
            {{ 'LISTS.NOT_FOUND' | translate }}
            <a (click)="goToCreateTab()">
              {{ 'LISTS.CREATE' | translate }}
            </a>
          }
        } @else {
          <mat-spinner [diameter]="30" style="margin: auto"></mat-spinner>
        }
      </div>
    </mat-tab>
    <mat-tab [label]="'LISTS.LIST_DIALOG.CREATE_NEW' | translate">
      <div class="tab-container">
        <mat-form-field class="new-list-input">
          <input
            matInput
            type="text"
            [placeholder]="'LISTS.LIST_DIALOG.ENTER_NAME' | translate"
            formControlName="createNewList"
            (keypress)="keyPressed($event)"
            />
        </mat-form-field>
      </div>
    </mat-tab>
  </mat-tab-group>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button matDialogClose color="primary">
    {{ 'COMMON.ACTION_LABELS.CANCEL' | translate }}
  </button>
  @if (!loading) {
    <button
      mat-flat-button
      button
      [disabled]="disableAddButton()"
      (click)="addAccountToList()"
      color="primary"
      >
      {{ submitText }}
    </button>
  }
  @if (loading) {
    <mat-spinner [diameter]="32" [strokeWidth]="4" [style.height.px]="32"></mat-spinner>
  }
</mat-dialog-actions>
